import { render, staticRenderFns } from "./legal-base-select.vue?vue&type=template&id=844a3b48"
import script from "./legal-base-select.vue?vue&type=script&lang=js"
export * from "./legal-base-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports